import React from 'react';
import PropTypes from 'prop-types';
import { inViewForReact } from 'utils/common';
import _get from 'lodash.get';
import LoadableComponentLoader from '../../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import s from './ShareWithProgressBar.scss';

class ShareWithProgressBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      progressBarWidth: 0,
      parentSocialWidgetVisible: false,
      headerHeight: 0,
    };
  }

  getArticleScrolledVal = () => {
    const activeMsid = this.props.activeMsid || this.props.msid;
    if (!this.articleElem || this.scrolledMsid !== activeMsid) {
      this.articleElem = document.querySelector(
        `[data-articlemsid="${activeMsid}"] [data-articlebody="1"]`,
      );
    }
    if (this.articleElem) {
      try {
        const isInView = inViewForReact(this.articleElem, 0, true);
        let width = 0;
        const elemRect = this.articleElem.getBoundingClientRect();
        if (elemRect && isInView && elemRect.top < 0) {
          const articleHeight =
            this.articleElem.offsetHeight - window.innerHeight;
          const articleScrolled = Math.abs(elemRect.top);
          width = Math.min(articleScrolled / articleHeight * 100, 100);
        }

        if (this.state.progressBarWidth !== width) {
          this.setState({ progressBarWidth: width });
        }
      } catch (e) {
        // console.log(e);
      }
    }
  };

  createProgressBar = () => {
    if (this.state.parentSocialWidgetVisible) {
      this.getArticleScrolledVal();
    }
  };

  handleSocialWidgetMobile = scrollingDown => {
    if (typeof document !== 'undefined') {
      let parentSocialWidgetVisible = false;
      const activeMsid = this.props.activeMsid || this.props.msid;
      let elem;
      let elemBottom;
      let header;
      let headerHeight = 0;
      let articleBodyElem;
      if (this.activeMsid === activeMsid && this.articleBodyElem) {
        articleBodyElem = this.articleBodyElem;
      } else {
        articleBodyElem = document.querySelector(
          `[data-articlemsid="${activeMsid}"] [data-articlebody="1"]`,
        );

        this.articleBodyElem = articleBodyElem;
      }

      if (this.activeMsid === activeMsid && this.activeSocialShare) {
        elem = this.activeSocialShare;
      } else {
        elem = document.querySelector(
          `[data-articlemsid="${activeMsid}"] .mob-share-button`,
        );
        this.activeSocialShare = elem;
      }

      if (this.activeMsid === activeMsid && this.activeSocialShareBottom) {
        elemBottom = this.activeSocialShareBottom;
      } else {
        elemBottom = document.querySelector(
          `[data-articlemsid="${activeMsid}"] .mob-share-button`,
        );
        this.activeSocialShareBottom = elemBottom;
      }

      if (!this.header) {
        header = document.querySelector('header');
        this.header = header;
      } else {
        header = this.header;
      }

      this.activeMsid = activeMsid;

      if (elem) {
        const elemBox = elem.getBoundingClientRect();
        if (header && !scrollingDown) {
          headerHeight = header.offsetHeight;
        }
        if (elemBox.top <= headerHeight) {
          parentSocialWidgetVisible = true;
        }
      }

      if (
        !articleBodyElem ||
        !inViewForReact(articleBodyElem, 0, true) ||
        (elemBottom && inViewForReact(elemBottom, 0, true))
      ) {
        parentSocialWidgetVisible = false;
      }

      if (
        parentSocialWidgetVisible !== this.state.parentSocialWidgetVisible ||
        headerHeight !== this.state.headerHeight
      ) {
        this.setState({ parentSocialWidgetVisible, headerHeight });
        const docklead = document.querySelector('.docklead');
        const dockleadSec = document.querySelector('.docklead section');
        if (docklead && docklead !== null) {
          if (
            this.state.headerHeight > 0 &&
            this.state.parentSocialWidgetVisible
            //document.querySelector(`.${s.fixSocial}`)
          ) {
            dockleadSec.style.transition = 'top 0.5s';
            dockleadSec.style.top = '82px';
          } else {
            dockleadSec.style.transition = 'top 0.1s';
            dockleadSec.style.top = '';
          }
        } else {
          const leadmedia = document.querySelector('.leadmedia');
          if (leadmedia && leadmedia !== null) {
            leadmedia.style.transition = 'top 0.1s';
            leadmedia.style.top = '';
          }
        }
      }
    }
  };

  getCommentsData = msid => {
    let commentCount = 0;
    if (this.props.comments && this.props.comments[`commentsData-${msid}`]) {
      const commentsData = this.props.comments[`commentsData-${msid}`];
      commentCount = commentsData[0] ? commentsData[0].totalcount : 0;
    }

    return commentCount;
  };

  render() {
    const {
      articleshowDataActive,
      categoryForGA,
      activeMsid,
      isAppView,
      isEtimesArticle,
    } = this.props;
    return (
      <div
        className={`${s.fixSocialElem} ${
          this.state.parentSocialWidgetVisible ? s.fixSocial : ''
        } ${this.state.headerHeight > 0 ? s.fixSocialTop : ''}`}
      >
        {!isAppView && (
          <LoadableComponentLoader
            loadOnScroll
            isEtimesArticle={isEtimesArticle}
            loadableComponentName="SocialSharingMobile"
            msid={articleshowDataActive.id}
            isParent={false}
            url={articleshowDataActive.su || articleshowDataActive.wu}
            title={articleshowDataActive.hl}
            isWapView
            image={
              articleshowDataActive.images
                ? articleshowDataActive.images[0]
                : undefined
            }
            openSidebar={this.openSidebar}
            commentsCount={this.getCommentsData(activeMsid)}
            wu={articleshowDataActive.wu}
            via={articleshowDataActive.via}
            isTablet={false}
            commentModeration={_get(
              articleshowDataActive,
              'metaInfo.CommentModeration',
              '',
            )}
            hideSharingButtons
            hideSharingNative
            showComment
            gaCategory={categoryForGA}
            gaAction={isEtimesArticle ? 'Sticky_share' : 'click'}
            gaIndex={isEtimesArticle ? '' : 'atfStickyShare_'}
            sticky
            tpShow
          />
        )}

        <div
          className={s.background}
          style={{ width: `${this.state.progressBarWidth}%` }}
        />
      </div>
    );
  }
}

ShareWithProgressBar.propTypes = {
  articleshowDataActive: PropTypes.shape({}),
  activeMsid: PropTypes.string,
  isEtimesArticle: PropTypes.bool,
  categoryForGA: PropTypes.string,
  isAppView: PropTypes.bool,
  msid: PropTypes.string,
  comments: PropTypes.shape([]),
};
ShareWithProgressBar.defaultProps = {
  articleshowDataActive: {},
  isEtimesArticle: false,
  activeMsid: '',
  categoryForGA: '',
  msid: '',
  isAppView: false,
  comments: [],
};

export default ShareWithProgressBar;
